import brand from '@helpers/brand';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';
const Background = styled(m.div) `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background: ${rgba(brand.primary.black, 0.8)};
  height: 100%;
  width: 100%;
  backdrop-filter: blur(3px);

  &[data-close='true'] {
    cursor: zoom-out;
  }
`;
const BackgroundStyles = {
    Background,
};
export default BackgroundStyles;
